// moduels
import dayjs from 'dayjs';
import type { ChardDashboardOverview } from '../models';

// libraries
import { atom, selector } from 'recoil';

/** 차트 대시보드 개요 초기값 */
export const initialProjectDashboardOverview: ChardDashboardOverview = {
  /** 프로젝트 개요 초기값 */
  projectOverview: {
    projectName: '',
    contractorName: '',
    projectStartDate: '',
    projectEndDate: '',
    progress: 0
  },
  /** 오늘의 출입 초기값 */
  todayEntry: {
    contents: []
  },
  /** 회사별 직접 인력 초기값 */
  companyDirectMP: {
    contents: []
  },
  /** 직종별 직접 인력 초기값 */
  occupationDirectMP: {
    contents: []
  },
  /** 주간 직접 인력 트렌드 초기값 */
  weeklyDirectManpowerTrend: {
    contents: []
  },
  weather: {
    weatherId: '',
    weatherIcon: '02d',
    weatherMain: 'Clear',
    weatherDescription: 'clear sky',
    environmentTime: '2025-03-06 13:01',
    windDirectionMin: 310,
    windDirectionAverage: 310,
    windDirectionMax: 310,
    windSpeedMin: 4.63,
    windSpeedAverage: 4.63,
    windSpeedMax: 4.63,
    temperatureAir: 28.96,
    temperatureMin: 21.96,
    temperatureMax: 21.96,
    temperatureObj: 27.46,
    heatIndex: 27.46,
    relativeHumidity: 21,
    atmosphericPressure: 1017,
    cumulativePrecipitation: 0,
    pm1: 0,
    pm2_5: 0,
    pm10: 0,
    dataKey: 'Dubai'
  },
  weather1h: [],
  noticeSummary: {
    notices: []
  }
};

export const ChartDashboardAtom = atom<ChardDashboardOverview>({
  key: 'ChartDashboardAtom',
  default: initialProjectDashboardOverview
});

export const ChartDashboardLastUpdatedAtom = atom<dayjs.Dayjs>({
  key: 'ChartDashboardLastUpdatedAtom',
  default: dayjs()
});

export const ChartDashboardProjectInfoAtom = selector<ChardDashboardOverview['projectOverview']>({
  key: 'ChartDashboardProjectInfoAtom',
  get: ({ get }) => {
    const { projectOverview } = get(ChartDashboardAtom);

    return projectOverview;
  }
});

export const ChartDashboardTodayEntryAtom = selector<
  ChardDashboardOverview['todayEntry']['contents']
>({
  key: 'ChartDashboardTodayEntryAtom',
  get: ({ get }) => {
    const { todayEntry } = get(ChartDashboardAtom);

    return todayEntry.contents;
  }
});

export const ChartDashboardCompanyDirectMPAtom = selector<
  ChardDashboardOverview['companyDirectMP']['contents']
>({
  key: 'ChartDashboardCompanyDirectMPAtom',
  get: ({ get }) => {
    const { companyDirectMP } = get(ChartDashboardAtom);

    return companyDirectMP.contents;
  }
});

export const ChartDashboardOccupationDirectMPAtom = selector<
  ChardDashboardOverview['occupationDirectMP']['contents']
>({
  key: 'ChartDashboardOccupationDirectMPAtom',
  get: ({ get }) => {
    const { occupationDirectMP } = get(ChartDashboardAtom);

    return occupationDirectMP.contents;
  }
});

export const ChartDashboardWeeklyDirectManpowerTrendAtom = selector<
  ChardDashboardOverview['weeklyDirectManpowerTrend']['contents']
>({
  key: 'ChartDashboardWeeklyDirectManpowerTrendAtom',
  get: ({ get }) => {
    const { weeklyDirectManpowerTrend } = get(ChartDashboardAtom);

    return weeklyDirectManpowerTrend.contents;
  }
});

export const ChartDashboardWeatherAtom = selector<ChardDashboardOverview['weather']>({
  key: 'ChartDashboardWeatherAtom',
  get: ({ get }) => {
    const { weather } = get(ChartDashboardAtom);

    return weather;
  }
});

export const ChartDashboardWeather1hAtom = selector<ChardDashboardOverview['weather1h']>({
  key: 'ChartDashboardWeather1hAtom',
  get: ({ get }) => {
    const { weather1h } = get(ChartDashboardAtom);

    return weather1h;
  }
});

export const ChartDashboardNoticeSummaryAtom = selector<
  ChardDashboardOverview['noticeSummary']['notices']
>({
  key: 'ChartDashboardNoticeSummaryAtom',
  get: ({ get }) => {
    const { noticeSummary } = get(ChartDashboardAtom);

    return noticeSummary.notices;
  }
});
